// extracted by css-extract-rspack-plugin
export default {"badge_icon":"H6FLy","badgeIcon":"H6FLy","isHide":"Oa92c","desktop_override":"QvSYW","desktopOverride":"QvSYW","#":"U_YtN","mobile_override":"WZgJJ","mobileOverride":"WZgJJ"};